import React from "react";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br';
import '@ckeditor/ckeditor5-build-classic/build/translations/en-gb';
import {useUser} from "store/providers/app";
import api from "../../services/api";

import {useLocation} from "react-router";

export default function Editor({ handleChange= null, disabled = false, ...props }) {

    const { language, username } = useUser();

    let lang = ''
    language === 'en-US' ? lang = 'en-gb' : lang = 'pt-br'

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();

                    loader.file.then((file) => {
                        body.append("file", file);
                        body.append("username", username);

                        api.post(`/images`, body)
                            .then((res) => {

                                 resolve({
                                    default: res.data.image.url
                                 });
                            })
                            .catch((err) => {

                                console.log(err)
                              //  reject(err);
                            });
                    });
                });
            }
        };
    }
    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    return (
        <div className="App">
            <CKEditor
                disabled={disabled}
                config={{
                    language: lang,
                    extraPlugins: [uploadPlugin],
                    mediaEmbed: {
                        elementName: 'o-embed',
                        previewsInData: true,
                        semanticDataOutput: true,
                    },
                    toolbar: [
                        'bold', 'italic', 'Underline', '|',
                        'numberedList', 'bulletedList','|',
                        'link','uploadImage','mediaEmbed'
                    ],
                    shouldNotGroupWhenFull: true,
                }}
                editor={DecoupledEditor}
                onReady={ editor => {
                    if (!disabled) {
                        editor.ui.getEditableElement().parentElement.insertBefore(
                            editor.ui.view.toolbar.element,
                            editor.ui.getEditableElement(),
                        );
                    }
                } }
                onBlur={(event, editor) => {}}
                onFocus={(event, editor) => {}}
                onChange={(event, editor) => {
                    handleChange(props.name, editor.getData());
                }}
                {...props}
            />
        </div>
    );
}
